module.exports = __webpack_public_path__ + "static/media/logo_txt.1fdd44a8.jpeg";